import { IRootState } from '../../../store'
import { IDestinationAddressOptionsState } from '../store/options.types'

export const getDestinationAddressOptionsSelector = (state: IRootState): IDestinationAddressOptionsState =>
  state.options.destinationAddressOptions
